import React from 'react'
import styles from './EnquiryFeeNPaymentPlan.module.css'

const EnquiryFeeNPaymentPlan = () => {
    return (
        <div>EnquiryFeeNPaymentPlan</div>
    )
}

export default EnquiryFeeNPaymentPlan